// extracted by mini-css-extract-plugin
export var box = "_54-2";
export var checkboxControl = "_54-0";
export var checkboxRow = "_54-a";
export var checked = "_54-3";
export var descriptionSpacer = "_54-c";
export var disabled = "_54-4";
export var icon = "_54-8";
export var input = "_54-1";
export var labelSpacer = "_54-b";
export var large = "_54-7";
export var medium = "_54-6";
export var small = "_54-5";
export var text = "_54-9";